<template>
  <div class="flex flex-nowrap">
    <MenuItem
      v-for="item in allItems"
      :key="item.key"
      :item="item"
      :class="itemClass"
      :item-active-class="itemActiveClass"
      @pageChanged="$emit('pageChanged')"
    />
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import MenuItemsMixin from './menuItemsMixin.js';
import MenuItem from './MenuItem.vue';

export default {
  name: 'NavigationMenu',
  mixins: [MenuItemsMixin],
  components: {
    MenuItem,
  },

  computed: {
    ...mapGetters([
      'catalogSettings',
      'chessSettings',
      'infoSettings',
      'project',
      'interactiveSettings',
      'premisesSettings',
      'catalogs',

      'estates',
    ]),

    allItems() {
      return this.menuItems.filter((i) => i.show);
    },
  },
  props: {
    itemClass: {
      type: String,
      default: '',
    },
    itemActiveClass: {
      type: String,
      default: '',
    },
  },
  methods: {},
};
</script>
